<template>
  <div v-if="offer" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget>
      <OfferForm :offer="offer" :isReadOnly="isReadOnly" @update:offer="offerLocalUpdate" />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :isReadOnly="isReadOnly"
            :model="offer"
            modelEditRoute="OfferEditPage"
            modelListRoute="OffersPage"
            modelRouteParamName="offerNumber"
            :updateCallback="handleUpdateOffer"
            :createCallback="handleCreateOffer"
            :deleteCallback="deleteOffer"
            :fetchPaginatedCallback="fetchOffersPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import OfferForm from '@/components/Offers/OfferForm.vue';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { OFFERS_ACCESS_NODE } from '@/navigation/accessNodes';

const NEW_OFFER_NUMBER = '_new';

export default {
  name: 'OfferEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    OfferForm,
  },
  props: {
    offerNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getOfferByNumber', 'getAccessLevel']),
    /** Viewer on the view offers: reads, cannot save or delete. */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(OFFERS_ACCESS_NODE), 'editor');
    },
    buttons() {
      const isStoredOffer = Boolean(this.offer) && this.offer.number !== NEW_OFFER_NUMBER;
      return {
        showDeleteButton: isStoredOffer && !this.isReadOnly,
      };
    },
    offer() {
      return this.getOfferByNumber(this.number ?? this.offerNumber);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('offers'), route: { name: 'OffersPage' } },
        { name: this.offer.number !== NEW_OFFER_NUMBER ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchOffersPaginated',
      'fetchOfferByNumber',
      'updateOffer',
      'createOffer',
      'deleteOffer',
      'initOffer',
      'offerLocalUpdate',
    ]),

    handleCreateOffer(offer) {
      return this.createOffer({ offer });
    },

    handleUpdateOffer(offer) {
      return this.updateOffer({ offer });
    },
  },
  async mounted() {
    if (this.offerNumber) {
      this.number = this.offerNumber;
      if (!this.offer) {
        await this.fetchOfferByNumber({ offerNumber: this.number });
      }
    } else {
      this.initOffer();
      this.number = NEW_OFFER_NUMBER;
    }
  },
};
</script>
